import { render, staticRenderFns } from "./addNewProduct-old.vue?vue&type=template&id=64923b2a"
import script from "./addNewProduct-old.vue?vue&type=script&lang=js"
export * from "./addNewProduct-old.vue?vue&type=script&lang=js"
import style0 from "./addNewProduct-old.vue?vue&type=style&index=0&id=64923b2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports